import React, { useState } from 'react';
import { TicketListContainer, ListHeader } from '../../styled-comps';
import { ViewTabsRow, ViewTab } from './styled';
import { SENIOR_ROLES, VIEW_INBOX, VIEW_SEARCH, VIEW_TEAMS } from '../../constants';
import InboxView from './inbox-view';
import SearchUsersView from './search-users-view';
import TeamsView from './teams-view';

const LeftPanel = ({
  activeTicketId,
  onPickTicket,
  userRole,
  isOnline,
  readTicketIds,
}) => {
  const isLead = SENIOR_ROLES.indexOf(userRole) !== -1;
  const [view, setView] = useState(VIEW_INBOX);

  return (
    <TicketListContainer as="aside">
      <ListHeader>
        <ViewTabsRow>
          <ViewTab $active={view === VIEW_INBOX} onClick={() => setView(VIEW_INBOX)}>
            Inbox
          </ViewTab>
          <ViewTab $active={view === VIEW_SEARCH} onClick={() => setView(VIEW_SEARCH)}>
            Search Users
          </ViewTab>
          {isLead && (
            <ViewTab $active={view === VIEW_TEAMS} onClick={() => setView(VIEW_TEAMS)}>
              Teams
            </ViewTab>
          )}
        </ViewTabsRow>
      </ListHeader>

      {view === VIEW_INBOX && (
        <InboxView
          activeTicketId={activeTicketId}
          onPickTicket={onPickTicket}
          isLead={isLead}
          isOnline={isOnline}
          readTicketIds={readTicketIds}
        />
      )}

      {view === VIEW_SEARCH && (
        <SearchUsersView activeTicketId={activeTicketId} onPickTicket={onPickTicket} />
      )}

      {view === VIEW_TEAMS && <TeamsView />}
    </TicketListContainer>
  );
};

export default LeftPanel;
